import React from 'react'
import { useTranslation } from 'react-i18next'
import { EnergyTab as EnergyTabUI } from '../../../../EnergyTab'
import { useAnalysisMode } from '../../../contexts/AnalysisModeContext'

/**
 * Shared EnergyTab wrapper for analysis views.
 * Reads entity data from AnalysisModeContext and delegates
 * to the existing EnergyTab component.
 */
export const EnergyTab: React.FC = () => {
  const { t } = useTranslation('energy')
  const { entity } = useAnalysisMode()

  if (!entity) {
    return null
  }

  return <EnergyTabUI building={entity} t={t} />
}
